<template>
<div class="chapter">
<div class="inner_page">
<h1>Índice Analítico</h1>
<p><span href="#/c001" title="Link target outside of Sample">Página do Título</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Página dos Direitos Autorais</span></p>
<p><a href="#/c003">Um Rapaz para o Monstro de Tentáculos</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Sua classificação e suas recomendações diretas farão a diferença</span></p>
<p><span href="#/c005" title="Link target outside of Sample">Procurando outras ótimas leituras? | Seus livros, seu idioma</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a143ccc0